import type { TicketRequestSubcategoryI } from 'declarations/interfaces/ticketRequestSubcategories';

import { get } from './api';

export const getTicketRequestSubCategories: (
  roofTopId?: string
) => Promise<TicketRequestSubcategoryI[]> = async roofTopId => {
  const response = await get<TicketRequestSubcategoryI[]>(
    `/tickets/sub-categories`,
    roofTopId ? { roofTopId } : undefined
  );

  return response.data;
};

export const getTicketRequestSubCategoriesByCategoryId: (
  categoryId: number,
  roofTopId?: string
) => Promise<TicketRequestSubcategoryI[]> = async (categoryId, roofTopId) => {
  const response = await get<TicketRequestSubcategoryI[]>(
    `/ticket-request-categories/${categoryId}/sub-categories`,
    roofTopId ? { roofTopId } : undefined
  );

  return response.data;
};
